import { render, staticRenderFns } from "./passwordPolicy.vue?vue&type=template&id=a7925c1c&scoped=true&lang=html"
import script from "./passwordPolicy.vue?vue&type=script&lang=js"
export * from "./passwordPolicy.vue?vue&type=script&lang=js"
import style0 from "./passwordPolicy.vue?vue&type=style&index=0&id=a7925c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7925c1c",
  null
  
)

export default component.exports